import React, { useState, useEffect } from "react";

const useAutoplay = (autoplayDelay, length, goToNext) => {
  useEffect(() => {
    const autoplayTimer = setInterval(goToNext, autoplayDelay);

    return () => {
      clearInterval(autoplayTimer);
    };
  }, [autoplayDelay, goToNext, length]);
};

const Carousel = ({ images, autoplayDelay = 3000 }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const goToNext = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === images.length - 1 ? 0 : prevIndex + 1
    );
  };

  useAutoplay(autoplayDelay, images.length, goToNext);

  return (
    <div className="relative md:h-[80vh] h-[50vh] ">
      <div className="overflow-hidden absolute w-full h-full">
        <div className="bg-gradient-to-b from-[rgba(0,0,0,0.2)] to-[rgba(0,0,0,0.2)] absolute w-full h-full"></div>
        <img
          src={images[currentIndex]}
          alt="carousel"
          className="object-cover w-full h-full"
        />
      </div>
      <div className=" absolute h-full w-full ">
        <div className="flex justify-center items-center h-full  lg:px-32 md:px-24 px-10 ">
          <div className=" text-white text-center border px-8  py-6 rounded-2xl bg-[rgba(0,0,0,0.7)] ">
            <h1 className="md:text-4xl text-2xl uppercase yellow-color pb-2  ">
              Deals In
            </h1>
            <h1 className="lg:text-2xl md:text-3xl main-heading uppercase text-base  lg:tracking-wide">
              GRAPHIC DESIGN | BOOKILLUSTRATION | PUBLISHING | OFFSET PRINTING |
              PACKAGING <br className="hidden md:block" /> uv printing | digital
              printing | SHIELDS & MEDALS | Etching process | GRAVURE & FLEXO{" "}
              <br className="hidden md:block" /> PRINTING | photography | social
              media marketing | 3D sign bord | ui/ux design
            </h1>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Carousel;
